import React, {useState} from 'react';
import {
    HashRouter,
    Routes,
    Route,
} from "react-router-dom";
import Search from "./Search";
import Specimen from "./Specimen";

export default function App() {

    const [searchState,setSearchState] = useState({
        'term' : '',
        'searchType' : 'any',
        'hasType': false,
        'hasImages': false,
        'selectedCollection': 'any',
        'selectedType': 'any',
        'results': undefined
    })

    return (
        <HashRouter>
            <Routes>
                <Route path="/">
                    <Route index element={<Search state={searchState} setState={setSearchState} />} />
                    <Route path="specimen/:specimenId" element={<Specimen />} />
                </Route>
            </Routes>
        </HashRouter>
    );
}
